export const ADD_MULTIPLE = 'entities/partners/ADD_MULTIPLE';

export const ADD = 'entities/partners/ADD';
export const UPDATE = 'entities/partners/UPDATE';
export const REMOVE = 'entities/partners/REMOVE';

export enum PARTNER_STATUSES {
  accepted = 'accepted',
  rejected = 'rejected',
  pending = 'pending',
  inactive = 'inactive',
}
